export default {
  name: "Storage Area",
  columns: {
    storageAreaName: "Storage Area Name",
    storageAreaType: "Storage Area Type",
  },
};
